var map = {
	"./Logo_ined.svg": "ef7c",
	"./arrow-down.svg": "c874",
	"./arrow-up-down.svg": "220b",
	"./customIcons/test.svg": "ff46",
	"./document.png": "24c9",
	"./file-document.svg": "974b",
	"./footer-logo 1.svg": "cd43",
	"./icon-auth-logout.svg": "3d59",
	"./icon-auth-user.svg": "7307",
	"./icon-danger.svg": "cc89",
	"./icon-error.svg": "f519",
	"./icon-exit.png": "054c",
	"./icon-menu.png": "218d",
	"./icon-nav-indicators.svg": "261b",
	"./icon-nav-link.svg": "96af",
	"./icon-nav-lk.svg": "a66b",
	"./icon-nav-other.svg": "fff6",
	"./icon-primary.svg": "d413",
	"./icon-success.svg": "0212",
	"./icon-user.png": "e112",
	"./icon-warning.svg": "1575",
	"./list.svg": "99ad",
	"./logo-footer.svg": "9025",
	"./logo-img.svg": "2f78",
	"./logo-text.svg": "dcb9",
	"./logo.svg": "5b1c",
	"./logoIned.svg": "2cca",
	"./photo_2021-05-20_17-04-52.png": "77a6",
	"./table.svg": "979b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";